import React from "react";

const PaginationButtons = ({ totalPages, currentPage, onChangePage }) => {
  const maxVisiblePages = 3;
  const buttons = [];

  if (totalPages > 0) {
    buttons.push(
      <button key={1} className={`flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-none cursor-pointer ${currentPage === 1 ? "bg-[#006666]" : "bg-[#008080] hover:bg-[#009999]"}`} onClick={() => onChangePage(1)}>
        1
      </button>
    );
  }

  let startPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(2, endPage - maxVisiblePages + 1);
  }

  if (startPage > 2) {
    buttons.push(
      <span key="ellipsis-start" className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white cursor-default bg-[#008080]">
        ...
      </span>
    );
  }

  for (let i = startPage; i <= endPage; i++) {
    buttons.push(
      <button key={i} className={`flex items-center justify-center !px-4 h-10 text-base font-medium text-white cursor-pointer ${currentPage === i ? "bg-[#006666]" : "bg-[#008080] hover:bg-[#009999]"}`} onClick={() => onChangePage(i)}>
        {i}
      </button>
    );
  }

  if (endPage < totalPages - 1 && totalPages > 1) {
    buttons.push(
      <span key="ellipsis-end" className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white cursor-default bg-[#008080]">
        ...
      </span>
    );
  }

  if (totalPages > 1) {
    buttons.push(
      <button key={totalPages} className={`flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-none cursor-pointer ${currentPage === totalPages ? "bg-[#006666]" : "bg-[#008080] hover:bg-[#009999]"}`} onClick={() => onChangePage(totalPages)}>
        {totalPages}
      </button>
    );
  }

  return (
    <div className="inline-flex !mt-2 xs:mt-0">
      <button className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-s cursor-pointer bg-[#008080] hover:bg-[#009999] disabled:bg-[#006666]" onClick={() => onChangePage(currentPage - 1)} disabled={currentPage === 1}>
        Prev
      </button>

      {buttons}

      <button className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-e cursor-pointer bg-[#008080] hover:bg-[#009999] disabled:bg-[#006666]" onClick={() => onChangePage(currentPage + 1)} disabled={currentPage === totalPages}>
        Next
      </button>
    </div>
  );
};

export default PaginationButtons;
